import React, { useEffect, useRef } from "react";

interface QuestionFormModalProps {
  open: boolean;
  onClose: () => void;
}

const QuestionFormModal: React.FC<QuestionFormModalProps> = ({
  open,
  onClose,
}) => {
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const previousActiveElement = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!open) return;

    previousActiveElement.current = document.activeElement as HTMLElement;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";

    const script = document.createElement("script");
    script.src = "https://yes.iamieshiadanielle.com/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);

    const focusTimer = setTimeout(() => {
      closeButtonRef.current?.focus();
    }, 50);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
      script.remove();
      clearTimeout(focusTimer);
      previousActiveElement.current?.focus();
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="question-form-modal-title"
    >
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative bg-[#FAF6F0] rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between px-6 py-4 border-b border-[#E8DEC8] sticky top-0 bg-[#FAF6F0] z-10">
          <h2
            id="question-form-modal-title"
            className="font-serif text-lg sm:text-xl font-normal text-[#380C1E]"
          >
            Questions About the Becoming Intensive?
          </h2>
          <button
            ref={closeButtonRef}
            onClick={onClose}
            aria-label="Close question form"
            className="text-[#380C1E]/50 hover:text-[#380C1E] text-3xl leading-none flex-shrink-0 ml-4"
          >
            &times;
          </button>
        </div>
        <div className="p-4 sm:p-6">
          <div className="w-full" style={{ minHeight: "600px" }}>
            <iframe
              src="https://yes.iamieshiadanielle.com/widget/form/tWqKIiFw4b0VWMTctmKv"
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                borderRadius: "8px",
                minHeight: "600px",
              }}
              id="inline-tWqKIiFw4b0VWMTctmKv"
              data-layout='{"id":"INLINE"}'
              data-trigger-type="alwaysShow"
              data-trigger-value=""
              data-activation-type="alwaysActivated"
              data-activation-value=""
              data-deactivation-type="neverDeactivate"
              data-deactivation-value=""
              data-form-name="BECOMING INTENSIVE QUESTION FORM"
              data-height="undefined"
              data-layout-iframe-id="inline-tWqKIiFw4b0VWMTctmKv"
              data-form-id="tWqKIiFw4b0VWMTctmKv"
              data-cookie-consent="true"
              data-cookie-consent-provider="auto"
              title="BECOMING INTENSIVE QUESTION FORM"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionFormModal;
